import TableCellRenderer from '../../../../table/TableCellRenderer'
import messageResource from '../../../../messageResource'
import $ from 'jquery'

function BalanceCellRenderer ()
{
    this.constructor = BalanceCellRenderer;
}

BalanceCellRenderer.prototype = _.create(TableCellRenderer.prototype, {

    /**
     @param handlers contains functions-handlers as properties
     */
    init: function({
            onClickHandler = () => {},
            onMouseOverHandler = () => {},
            onMouseOutHandler = () => {}
        }, ptoHoursPerDay
    ) {
        TableCellRenderer.call(this)

        this.onClickHandler = onClickHandler
        this.onMouseOverHandler = onMouseOverHandler
        this.onMouseOutHandler = onMouseOutHandler

        this.daysFormatter =
                new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, this.roundBalance() ? 0 : 2, true, '',
                        messageResource.getMessage('common.pto_units.days.short'));
        this.hoursFormatter =
                new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, this.roundBalance() ? 0 : 2, true, '',
                        messageResource.getMessage('common.pto_units.hours.short'));

        this.ptoHoursPerDay = ptoHoursPerDay;

        return this;
    },

    getCellGeneralClassName: function()
    {
        return "currentBalanceCell";
    },

    roundBalance: function()
    {
        //abstract
    },

    getFlagValue: function()
    {
        //abstract
    },

    getCurrentBalanceFromValue: function(value)
    {
        //abstract
    },

    showBalanceInHours: function()
    {
        //abstract
    },

    getNotStartedText: function()
    {
        //abstract
    },

    getCellClassName: function(cell)
    {
        var classes = [this.getCellGeneralClassName()],
                value = cell.getValue();

        if (!this.getFlagValue(value))
        {
            classes.push("off");
        }
        else
        {
            if (this.getCurrentBalanceFromValue(value).notStarted)
            {
                classes.push("notStarted");
            }
            else
            {
                classes.push("on");
            }
            if (this.showBalanceInHours() && this.hoursFormatter.isNegativeValue(this.getCurrentBalanceFromValue(value).balance * this.ptoHoursPerDay) ||
                !this.showBalanceInHours() && this.daysFormatter.isNegativeValue(this.getCurrentBalanceFromValue(value).balance))
            {
                classes.push("negative");
            }
        }

        return classes;
    },

    generateContent: function(cell)
    {
        var value = cell.getValue();
        var cellEl = cell.getCellEl();
        var content;
        var title = "";

        if (this.getFlagValue(value))
        {
            if (this.getCurrentBalanceFromValue(value).notStarted)
            {
                content = messageResource.getMessage("common.not_available_lower");
                title = this.getNotStartedText();
            }
            else
            {
                if (this.showBalanceInHours())
                    content = this.hoursFormatter.format(this.getCurrentBalanceFromValue(value).balance * this.ptoHoursPerDay);
                else
                    content = this.daysFormatter.format(this.getCurrentBalanceFromValue(value).balance);

                if (this.onClickHandler)
                    cellEl.onclick = () => this.onClickHandler(cell)

                if (this.onMouseOverHandler)
                    $(cellEl).hover(e => this.onMouseOverHandler(e), this.onMouseOutHandler)
            }
        }
        else
        {
            content = messageResource.getMessage("userlist.js.table.ptoCell.off");
        }

        cellEl.innerHTML = content;
        cellEl.title = title;
    }
});

export default BalanceCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/BalanceCellRenderer.js